var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `row flex-${_vm.position} ${_vm.wrapperStyling}`,
      attrs: { id: "container" },
    },
    [
      _c(
        "button",
        {
          class: `col xs-${_vm.mobile} md-${_vm.tablet} lg-${_vm.desktop} button ${_vm.styling}`,
          style: { height: _vm.height, "text-align": _vm.textAlign },
          attrs: { form: _vm.form, disabled: _vm.disabled },
          on: { click: _vm.onClickEventHandler },
        },
        [_vm._t("content")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }